import React from 'react';
import styles from './Footer.module.css';
import logo from '../../assets/images/logo.png';

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'Share Valuation Engine', href: '#sve' },
      { label: 'Credit Scoring Engine', href: '#cse' },
      { label: 'API Documentation', href: '#api' },
      { label: 'Pricing', href: '#pricing' }
    ],
    company: [
      { label: 'About Us', href: '#about' },
      { label: 'Careers', href: '#careers' },
      { label: 'Partners', href: '#partners' },
      { label: 'Contact', href: '#contact' }
    ],
    resources: [
      { label: 'Documentation', href: '#docs' },
      { label: 'Case Studies', href: '#cases' },
      { label: 'Blog', href: '#blog' },
      { label: 'Support', href: '#support' }
    ],
    legal: [
      { label: 'Privacy Policy', href: '#privacy' },
      { label: 'Terms of Service', href: '#terms' },
      { label: 'Data Protection', href: '#data' },
      { label: 'Compliance', href: '#compliance' }
    ]
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>

        {/* Main Footer Content */}
        <div className={styles.mainContent}>

          {/* Brand Section */}
          <div className={styles.brandSection}>
            <div className={styles.logo}>
              <div className={styles.logoIconWrapper}>
                <img src={logo} alt="Scorex Logo" className={styles.logoIcon} />
              </div>
            
            </div>
            <p className={styles.tagline}>
              AI-powered credit intelligence for financial institutions across Africa
            </p>
            <div className={styles.contact}>
              <a href="mailto:hello@scorex.io" className={styles.contactLink}>hello@scorex.io</a>
              <a href="tel:+254708277848" className={styles.contactLink}>+254 708 277 8484</a>
            </div>
          </div>

          {/* Links Sections */}
          <div className={styles.linksGrid}>
            <div className={styles.linkColumn}>
              <h3 className={styles.columnTitle}>Product</h3>
              <ul className={styles.linkList}>
                {footerLinks.product.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={styles.link}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.linkColumn}>
              <h3 className={styles.columnTitle}>Company</h3>
              <ul className={styles.linkList}>
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={styles.link}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.linkColumn}>
              <h3 className={styles.columnTitle}>Resources</h3>
              <ul className={styles.linkList}>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={styles.link}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.linkColumn}>
              <h3 className={styles.columnTitle}>Legal</h3>
              <ul className={styles.linkList}>
                {footerLinks.legal.map((link, index) => (
                  <li key={index}>
                    <a href={link.href} className={styles.link}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className={styles.bottomBar}>
          <div className={styles.bottomLeft}>
            <span className={styles.copyright}>
              © {new Date().getFullYear()} Scorex Limited
            </span>
            <span className={styles.divider}>·</span>
            <span className={styles.location}>Nairobi, Kenya</span>
          </div>

          <div className={styles.socialLinks}>
            <a href="#linkedin" className={styles.socialLink} aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.6667 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H16.6667C17.1269 17.5 17.5 17.1269 17.5 16.6667V3.33333C17.5 2.8731 17.1269 2.5 16.6667 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.5 8.75V13.75M7.5 6.25V6.2625M12.5 13.75V10.625C12.5 10.1277 12.3025 9.65081 11.9508 9.29917C11.5992 8.94754 11.1223 8.75 10.625 8.75C10.1277 8.75 9.65081 8.94754 9.29917 9.29917C8.94754 9.65081 8.75 10.1277 8.75 10.625V13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a href="#twitter" className={styles.socialLink} aria-label="Twitter">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15.8333 2.5H18.3333L12.5 9.16667L19.1667 17.5H13.75L9.58333 12.0833L4.83333 17.5H2.33333L8.58333 10.4167L2.16667 2.5H7.75L11.5 7.5L15.8333 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <a href="#github" className={styles.socialLink} aria-label="GitHub">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 13.6842 4.01184 16.8053 7.24122 17.9605C7.65789 18.0395 7.8125 17.7895 7.8125 17.5789C7.8125 17.3947 7.80592 16.8842 7.80263 16.2105C5.47039 16.7105 5.00658 15.0789 5.00658 15.0789C4.63158 14.0658 4.10526 13.8158 4.10526 13.8158C3.38158 13.3026 4.15789 13.3158 4.15789 13.3158C4.95395 13.3684 5.37171 14.1579 5.37171 14.1579C6.09211 15.4079 7.26316 15.0526 7.82895 14.8553C7.90132 14.3289 8.10526 13.9737 8.33333 13.7895C6.55263 13.6053 4.68421 12.9211 4.68421 9.73684C4.68421 8.78947 5.00658 8.01316 5.38816 7.40789C5.30263 7.22368 5.03289 6.42105 5.46711 5.30263C5.46711 5.30263 6.14474 5.09211 7.78947 6.19079C8.43421 6.02632 9.12171 5.94079 9.80263 5.93421C10.4836 5.94079 11.1711 6.02632 11.8158 6.19079C13.4605 5.09211 14.1382 5.30263 14.1382 5.30263C14.5724 6.42105 14.3026 7.22368 14.2171 7.40789C14.5987 8.01316 14.9211 8.78947 14.9211 9.73684C14.9211 12.9276 13.0461 13.6053 11.2655 13.7895C11.5461 14.0395 11.8026 14.5395 11.8026 15.2895C11.8026 16.3553 11.7895 17.2171 11.7895 17.5789C11.7895 17.7895 11.9408 18.0461 12.3618 17.9605C15.5912 16.8053 17.9342 13.6842 17.9342 10C17.9342 5.39763 14.2024 1.66667 9.6 1.66667H10Z" fill="currentColor" />
              </svg>
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;